<template>
	<div v-if="subjectData">
		<v-container class="global-margin pb-0 mb-0">
			<v-breadcrumbs :items="breadcrumbs" class="breadcrumbs pl-0" large></v-breadcrumbs>
		</v-container>
		<v-container class="content-wrap">
			<v-row class="w-100 flex-center mx-0">
				<v-col cols="12" md="8" class="flex-center flex-column">
					<h1 class="display-2 w-100 mb-4">
						{{subjectData.title}}
					</h1>

					<p v-if="subjectData.text" class="w-100 text-justify my-12 mb-5">
						Opis: {{subjectData.text}}
					</p>

					<v-alert v-if="subjectData.is_scheduled"
							 icon="mdi-school"
							 prominent
							 class="pl-8 w-100"
							 text
							 border="left"
							 type="warning">
						<v-row align="center">
							<v-col class="grow">Sadržaj dostupan {{subjectData.is_scheduled.schedule_date | moment('D.M.YYYY.')}} od 9:00.</v-col>
							<v-col class="shrink">
								<v-btn rounded outlined color="warning"
									   class="text-capitalize"
									   :to="'/raspored/' + subjectData.school_class.id">
									Raspored nastave
								</v-btn>
							</v-col>
						</v-row>
					</v-alert>

					<template v-if="subjectData.contents && subjectData.contents.length !== 0">
						<template v-for="(item, index) in subjectData.contents" >
							<sum-content :item="item" :key="'sadrzaj'+index"></sum-content>
						</template>
					</template>

					<v-alert v-else-if="!subjectData.is_scheduled" text color="red" border="left" class="w-100 pl-7 mt-3">
						Za ovu lekciju nema sadržaja.
					</v-alert>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>

	import SumContent from "../components/SumContent";

	export default {
		name: "RazredLekcije",
		components: {SumContent},
		data() {
			return {
				subjectID: this.$route.params.id,
				subjectData: null,
				breadcrumbs: [
					{
						text: 'Naslovnica',
						disabled: false,
						to: '/'
					},
					{
						text: 'Lekcije',
						disabled: false,
						href: '/lekcije'
					}
				]
			}
		},
		created() {
			skoleApi.get("/lekcije/" + this.subjectID, {
				params:{
					force: this.$route.query.force
				}
			}).then(response => {
				if (response.status == 200) {
					this.subjectData = response.data;

					let type = 'osnovna';
					let naziv = this.subjectData.school_class.grade + '. Razred';

					if (this.subjectData.school_class.grade === 10) {
						naziv = 'Ostalo';
					}

					if (this.subjectData.school_class.high_school == 1) {
						type = 'srednja';
						naziv += ' SŠ'
					}

					let razred = {
						text: naziv,
						disabled: false,
						to: '/predmeti/' + type +'/' + this.subjectData.school_class.grade
					};

					this.breadcrumbs.push(razred);

					this.breadcrumbs.push({
						text: this.subjectData.course.title,
						disabled: true
					});

					if (this.subjectData.content_type_id !== 1 && this.subjectData.parent) {
						this.breadcrumbs.push({
							text: this.subjectData.parent.title,
							to: '/lekcije/' + this.subjectData.parent.id,
							disabled: false
						});
					}

					this.breadcrumbs.push({
						text: this.subjectData.title,
						disabled: true
					});

				}
			}).catch(error => {
				if (error.response.status === 404) {
					this.$router.replace('/404');
				}
			})
		}
	};
</script>

<style lang="scss">
	.razred-lekcije {
		margin-top: 150px;
	}

	@media(max-width: 768px) {
		.razred-lekcije {
			margin-top: 120px !important;
		}
	}

	.content-video {
		width: 100% !important;
		min-height: 500px;
	}

	.blue-sumit-color {
		color: #094776;
	}

	.moodle-btn {
		letter-spacing: 0 !important;
		border-radius: 30px;
	}
</style>
